import { TabContainer } from "../../components/SocialCaseTbas/Social.styled";
import { ComplaintContainer, Label } from "../complaint/Complaint.styled";
import { Header } from "./Booking.styled";
import calendar from '../../assets/calendar.svg'
import { LabelDiv } from "../../components/PaymentPlanTabs/Tabs.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import appointmentStore from "../../stores/AppointmentStore";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";

import { Box, Typography, Tabs, Tab, Modal, Backdrop } from "@mui/material";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabPanelProps } from "../Tabs.MUI/Tabs.interface";

import { useNavigate } from "react-router-dom";
import ManageBooking from "./ManageBooking";
import { SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { NotifySuccess } from "../../utils/ShowSuccess";
import { NotifyError } from "../../utils/ShowError";
import { DatePicker } from "antd";
import moment from "moment";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, padding, width, background, ...other } =
    props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: width, background: background,padding:General?.isLargeScreen?'':"0.8rem" }}
    >
      {value === index && (
        <Box sx={{ p: value === 3 ? 0 : 3, padding: "2px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const BookAppointment = () => {

  const branchCodeRef = useRef<HTMLSelectElement>(null)
  const serviceCodeRef = useRef<HTMLSelectElement>(null)
  const slotCodeRef = useRef<HTMLSelectElement>(null)

  const nameRef = useRef<HTMLInputElement>(null)
  const mobileRef = useRef<HTMLInputElement>(null)
  const [value, setValue] = useState<any>(0);
  const [selectedDate, setSelectedDate] = useState(null);

  const disabledDate = (current:any) => {
    // Disable dates before today or after two months from today
    return (
      current &&
      (current < moment().startOf("day") ||
        current > moment().add(2, "months").endOf("day") ||
        current.day() === 0 ||
        current.day() === 6)
    );
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // General?.handleBackClick();
    
  };
  const handleGetBranchList = async () => {
    await appointmentStore.getBranchList({ errorId: 'getBranchListError' })
  }

  const handleBranchSelect = async (e: ChangeEvent<HTMLSelectElement>) => {
    await appointmentStore.getServiceList({ errorId: 'getServiceListError', data: e.target.value })
  }
  const [disableBooking,setDisableBooking]=useState(false);
  
  const handleDateChange = async (date:any) => {

    let newDate = new Date(date)
    const data = {
      branchCode: branchCodeRef.current?.value,
      date: moment(newDate).format("DD-MMM-YYYY")
    }

    setSelectedDate(date);

   const res= await appointmentStore.getSlotsList({ errorId: 'getServiceListError', data })
    if(res?.length<1){
      
      setDisableBooking(true)
      NotifyError(General?.codeLabels['cm_entertimefield']?.label?General?.codeLabels['cm_entertimefield']?.label:"No slots available for this date ");
    }
  }
  const [loading ,setLoading]=useState(false);
  const handleBookAppointment = async () => {
    setLoading(true);
    if(User?.profile?.mobileNumber==null&&User?.profile?.name==null){
      setLoading(true);
      NotifyError(General?.codeLabels['cm_mobilenumberreqerr']?.label);
      return;
    }
    const data = {
      branchCode: branchCodeRef.current?.value,
      serviceCode: serviceCodeRef.current?.value,
      name: User?.profile?.name?User?.profile?.name:"",
      syncId: User?.profile?.mobileNumber? User?.profile?.mobileNumber?.replace(/-/g,''):'',
      mobilePhoneNumber:User?.profile?.mobileNumber? User?.profile?.mobileNumber?.replace(/-/g,''):'',
      apptCode: null,
      apptDate: slotCodeRef.current?.value,
      apptTime: slotCodeRef.current?.value,
      startTime: slotCodeRef.current?.value,
    }

    let bookApt=   await appointmentStore.bookAppointment({ errorId: 'bookAppointmentError', data })
    if (
      bookApt &&
      bookApt?.result.wsMakeApptResp.error == null &&
      bookApt?.result.wsMakeApptResp.appt !== null
    ) {
      NotifySuccess('Appointment booked successful')
      setLoading(false);
    }else {
      NotifyError('Unable to book appointment.')
      NotifyError(bookApt?.result.wsMakeApptResp.error.reason);
    }
}
  const navigate = useNavigate();
  useEffect(() => {
    handleGetBranchList()
  }, [])
  const ColorAss = General?.ColorAss;
  const contrast=General?.contrast;
  return (
    <div>
      <MoveInHeader
        style={{
          background: contrast?.contrastBackground? contrast?.contrastBackground : "#62aa51",
            height:General?.isLargeScreen?"10em":"14rem",
          paddingTop: General?.isLargeScreen?"1rem":"5rem",
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
        }}
      >
        <div style={{ width: "90%", margin: "auto" }}>
          <MiniNav>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "rgba(98, 170, 81, 1)",
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex:'0'
              }}
             
              onClick={() =>
                navigate("/dashboard")
              }
            >
              {General?.codeLabels["cm_back"]?.label?General?.codeLabels["cm_back"]?.label:"BACK"}
            </ButtonSecondary>
        {!User?.info?.personId&& <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "rgba(98, 170, 81, 1)",
                  width:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "12rem":"117px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex:'0'
              }}
              onClick={() => navigate("/dashboard")}
            >
              
              {General?.codeLabels["cm_dashboard"]?.label?General?.codeLabels["cm_dashboard"]?.label:"DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1
           style={{
            width: "77vw",
            height: "48px",
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize:General?.isLargeScreen? `${3.1 * General.accessibility.fontSize}rem`:`${2*General.accessibility.fontSize}rem`,
            margin: "0",
            marginBottom: "3rem",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
          }}
          >
        {General?.codeLabels["cm_bookappointment"]?.label !== undefined ? General?.codeLabels["cm_bookappointment"]?.label : "Book Appointment"}            {}
          </h1>
        </div>
      </MoveInHeader>
     
      <ComplaintContainer style={{width:General?.isLargeScreen?"":"98%"}}>
      <Box
       sx={{
         display: "flex",
       }}
     >
      <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{ width: "100%" }}
            variant="scrollable"
            allowScrollButtonsMobile
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            <Tab
              label={<span className={General?.textClass? value !== 0? "whiteText":"blackText":value == 0?"":"whiteText"} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
                {General?.codeLabels["cm_bookappointment"]?.label !== undefined ? General?.codeLabels["cm_bookappointment"]?.label : "Book Appointment"}

              </span>}
              {...a11yProps(0)}
              className={`${value !== 0? General?.colorClass:"slctd"} ${value === 0 ? "slctd" : ""} tab-width`}
              sx={{
                color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
               height:General?.isLargeScreen? "3.75rem":"2rem",
                width:General?.isLargeScreen? "16.75rem":"12rem",
                fontSize: "1.125rem",
                fontWeight: "bold", zIndex: '0',
                "&.Mui-selected": {
                  color: "#fff",
                },
              }}
            />
            <Tab
              label={<span className={General?.textClass? value !== 1? "whiteText":"blackText":value == 1?"":"whiteText"} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
                {General?.codeLabels["cm_manageappointment"]?.label !== undefined ? General?.codeLabels["cm_manageappointment"]?.label : "Manage Appointment"}

              </span>}
              {...a11yProps(1)}
              className={`${value !== 1? General?.colorClass:"slctd"} ${value === 1 ? "slctd" : ""} tab-width`}
              sx={{
                color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
               height:General?.isLargeScreen? "3.75rem":"2rem",
                width:General?.isLargeScreen? "16.75rem":"12rem",
                fontSize: "1.125rem",
                fontWeight: "bold", zIndex: '0',
                "&.Mui-selected": {
                  color: "#fff",
                },
              }}
            />
          </Tabs>
          </Box>
          <TabPanel  value={value} index={0}>
            <Box>
            <TabContainer style={{ padding:General?.isLargeScreen? "50px":"",display:General?.isLargeScreen?'grid':'flex', flexDirection:General?.isLargeScreen?"row":"column"}}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "16px",
            lineHeight: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            gap: "0.5rem"
          }}>
          
            {General?.codeLabels["cm_selectbranchlabel"]?.label !== undefined ? General?.codeLabels["cm_selectbranchlabel"]?.label : "Which Customer Happiness Centre would you like to visit?"}?*

            <select ref={branchCodeRef} style={{
              width: "100%", height: "46px", background: "#e5eff2", color: "#101e8e", opacity: "1",
            }} onChange={handleBranchSelect}>
              <option value="select">

                {General?.codeLabels["cm_selectbranchname"]?.label !== undefined ? General?.codeLabels["cm_selectbranchname"]?.label : "Please Select Branch"}

              </option>
              {
                appointmentStore.branchList.map((branch) => {
                  return <option value={branch.branchCode}>{branch.branchName}</option>
                })
              }
            </select>
          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "16px",
            lineHeight: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            gap: "0.5rem"
          }}>
            {General?.codeLabels["cm_selectservicelabel"]?.label !== undefined ? General?.codeLabels["cm_selectservicelabel"]?.label : "How can we help you?"}
            *
            <select ref={serviceCodeRef} style={{ width: "100%", height: "46px", background: "#e5eff2", color: "#101e8e", opacity: "1" }}>
              <option value="select">

                {General?.codeLabels["cm_pdc_select"]?.label !== undefined ? General?.codeLabels["cm_pdc_select"]?.label : "Select"}

              </option>
              {
                appointmentStore.serviceList.map((service) => {
                  return <option value={service.serviceNo}>{service.serviceName}</option>
                })
              }
            </select>
          </div>
          <Label style={{
            fontSize: "16px",
            lineHeight: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            gap: "0.5rem"
          }}>

            {General?.codeLabels["cm_appointmentdatetimelabel"]?.label !== undefined ? General?.codeLabels["cm_appointmentdatetimelabel"]?.label : "When would you like to visit Customer Happiness Centre?"}

             <DatePicker
            disabledDate={disabledDate}
            value={selectedDate}
            placeholder={"Select Date"}
            //onChange={(date) => setSelectedDate(date)}
            onChange={handleDateChange}
            style={{
              color: contrast ? contrast.contrastColor : "#101e8e",
              width: "100%", height: "50px", background: "#e5eff2",  opacity: "1",
              borderRadius:'0px'
            }}
          />
          </Label>
          <div style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "16px",
            lineHeight: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            gap: "0.5rem"
          }}>

            {General?.codeLabels["cm_appointmenttimelabel"]?.label !== undefined ? General?.codeLabels["cm_appointmenttimelabel"]?.label : "Time"}

            <select ref={slotCodeRef} style={{ width: "100%", height: "51px", background: "#e5eff2", color: "#101e8e", opacity: "1" }}>

              <option value="select"> {General?.codeLabels["cm_pdc_select"]?.label !== undefined ? General?.codeLabels["cm_pdc_select"]?.label : "Select"}</option>
              {
                appointmentStore.slotsList.map((slot) => {
                  return <option value={slot.apptSlot.startTime}>{slot.apptSlot.startTime.split("T")[1]}</option>
                })
              }
            </select>
          </div>
        </TabContainer>
        <TabContainer style={{ padding:General?.isLargeScreen? "3rem":"1rem 0rem",display:General?.isLargeScreen?'grid':'flex', flexDirection:General?.isLargeScreen?"row":"column" }}>
         
         {General?.isLargeScreen&& <hr style={{ gridColumn: "1 / span 2", width: "100%" }} />}
          <ButtonSecondary onClick={handleBookAppointment} style={{ background: "#101e8e", color: "#fff", width:General?.isLargeScreen? '45%':"100%", padding: '10px',opacity:disableBooking?'0.5':'1' }} disabled={disableBooking}>
            {loading?<SpinnerRaw height={30} width={30}/>: General?.codeLabels["cm_bookappointment"]?.label !== undefined ? General?.codeLabels["cm_bookappointment"]?.label : "Book Appointment"}

          </ButtonSecondary>
        </TabContainer> 
            </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
            <ManageBooking MyAccountsWidth="100vw" MyAccountsOutline="none" />
            </TabPanel>
         
      </ComplaintContainer>
    </div>
  );
};

export default observer(BookAppointment);
